const dev = {
  GENERAL_SPECIALITY_ID: 2217,
};

const uat = {
  GENERAL_SPECIALITY_ID: 2114,
};

const prod = {
  GENERAL_SPECIALITY_ID: 2024,
};

const getEnv = () => {
  switch (process.env.REACT_APP_ENV) {
    case "dev":
      return dev;
    case "uat":
      return uat;
    case "prod":
    case "zy-preprod":
      return prod;
    case "zy-prod":
      return prod;
    default:
      break;
  }
};
export const env = getEnv();
